export enum AppBarVariant {
  PROSPECT = 'prospect',
  PROSPECT_PERSONALIZED = 'personalized-prospect',
  CLIENT_INACTIVE = 'client-inactive',
  CLIENT_ACTIVE = 'client-active',
  CAMPAIGN_PAGE = 'campaign-page'
}
